import { publicApi } from 'lib/api'
import to from 'lib/to'

export const getTestPeriod = () => to(publicApi.get('/testPeriod.json'))
